export const HEADER_OVERLAY_ATTR = 'data-header-overlay';

export const headerOverlayProps = {[HEADER_OVERLAY_ATTR]: ''};
